var path = 'src/app/observations/observations.html';
var html = "<div page-wrapper> <h1 class=page-header>Observations</h1> <div observations-component></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/observations/observations.html
 ** module id = 377
 ** module chunks = 0
 **/